module.exports = __webpack_public_path__ + "img/prioritas_sameday_cod_dg_k.a3601a89.png";